// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import ADYENPAYMENT_CONSTANTS from './AdyenPayment.constants';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '../../../../../utils/cache.util';

const initialState = fromJS({
  [DEFAULT_REDUCER_KEY]: null,
  adyenSessionData: null,
  adyenSetupData: null,
});

const AdyenPaymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADYENPAYMENT_CONSTANTS.SET_ADYEN_SESSION_DATA:
      return state
        .set('adyenSessionData', action.payload)
        .set(
          DEFAULT_REDUCER_KEY,
          setCacheTTL(action.payload?.cacheTTL || ADYENPAYMENT_CONSTANTS.ADYEN_SESSION_CACHE_TTL)
        );
    case ADYENPAYMENT_CONSTANTS.SET_ADYEN_SETUP_DATA:
      return state
        .set('adyenSetupData', action.payload)
        .set(
          DEFAULT_REDUCER_KEY,
          setCacheTTL(action.payload?.cacheTTL || ADYENPAYMENT_CONSTANTS.ADYEN_SESSION_CACHE_TTL)
        );
    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default AdyenPaymentReducer;
